import { Button, Paper, Skeleton, Stack, Typography } from '@mui/material'
import { useParams, useHistory } from 'react-router-dom'

import {
  AccountPayableRecordStatus,
  useGetAccountPayableRecordQuery,
  useGetMissingDriverPaymentDataFieldsQuery,
} from 'generated/graphql'

const MissingPaymentFieldsPanel = () => {
  const { id } = useParams<{ id?: string }>()
  const history = useHistory()

  const { data: orderDetails } = useGetAccountPayableRecordQuery({
    variables: { id: Number(id) },
  })

  const status = orderDetails?.accountPayableRecord?.status
  const disabledEdit =
    status === AccountPayableRecordStatus.PaymentSent ||
    status === AccountPayableRecordStatus.Archived

  const { data: missingPaymentData, loading } = useGetMissingDriverPaymentDataFieldsQuery({
    variables: {
      accountPayableRecordId: Number(id),
    },
    skip: !Number(id),
    fetchPolicy: 'network-only',
  })

  const missingPaymentDataFields = missingPaymentData?.missingDriverPaymentDataFields || []
  const paymentFields = missingPaymentDataFields?.join(', ')

  const handleEditClick = () => {
    const driverId = Number(
      orderDetails?.accountPayableRecord?.bookingInvoice.bookingDriver?.driver.primaryDriverId ??
        orderDetails?.accountPayableRecord?.bookingInvoice.bookingDriver?.driver.id,
    )

    history.push(`/suppliers/driver/${driverId}`)
  }

  if (loading) {
    return <Skeleton />
  }

  if (!missingPaymentDataFields.length) {
    return <></>
  }

  return (
    <Paper elevation={4}>
      <Stack direction='row' p={2} alignItems='center' justifyContent='space-between'>
        <Typography style={{ whiteSpace: 'pre-line' }}>
          Missing payment data: {paymentFields}
        </Typography>
        <Button variant='outlined' onClick={handleEditClick} disabled={disabledEdit}>
          EDIT
        </Button>
      </Stack>
    </Paper>
  )
}

export default MissingPaymentFieldsPanel
